import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

// ── UPDATE THESE VALUES EACH YEAR ──────────────────────────────────────────
const EVENT = {
  year: 2026,
  dateRange: 'May 16, 2026 - August 28, 2026',
  registrationDeadline: 'Open All Summer',
  location: 'Any Ontario Waterways',
  entryFee: '$20 per person',
  prizePool: 'TBD',
  contactEmail: 'jacob.reszitnyk@ontario.ca',
};
// ───────────────────────────────────────────────────────────────────────────

function Home() {
  return (
    <div>
      {/* Hero */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">🎣 Unofficial Fishing Derby {EVENT.year}</h1>
          <p className="hero-tagline">
            A season-long work derby from spring opener to late summer bragging rights.
          </p>
          <div className="hero-cta">
            <Link to="/register" className="btn btn-primary">Register Now</Link>
            <Link to="/leaderboard" className="btn btn-secondary">View Leaderboard</Link>
          </div>
        </div>
      </section>

      {/* Event Info */}
      <div className="page-container">
        <h2 className="page-title">Event Info</h2>
        <p className="page-subtitle">Everything you need to know about this year's derby.</p>

        <div className="info-grid">
          <div className="card info-card">
            <span className="info-icon">📅</span>
            <h3>Derby Dates</h3>
            <p>{EVENT.dateRange}</p>
          </div>
          <div className="card info-card">
            <span className="info-icon">📍</span>
            <h3>Location</h3>
            <p>{EVENT.location}</p>
          </div>
          <div className="card info-card">
            <span className="info-icon">💰</span>
            <h3>Entry Fee</h3>
            <p>{EVENT.entryFee}</p>
          </div>
          <div className="card info-card">
            <span className="info-icon">🏆</span>
            <h3>Prize Pool</h3>
            <p>{EVENT.prizePool}</p>
          </div>
          <div className="card info-card">
            <span className="info-icon">📋</span>
            <h3>Registration</h3>
            <p>{EVENT.registrationDeadline}</p>
          </div>
        </div>

        {/* About section */}
        <div className="card about-card">
          <h2>About the Derby</h2>
          <p>
            Welcome to the Unofficial Fishing Derby! This is a friendly competition
            open to all coworkers. Whether you're a seasoned angler
            or picking up a rod for the first time, everyone is welcome.
          </p>
          <p>
            Scoring this year is category based: Most Unique Catch, Smallest Cutest Catch,
            Largest Fish by Length, and Most Species Caught during the derby.
          </p>
          <p>
            Questions? Email us at{' '}
            <a href={`mailto:${EVENT.contactEmail}`}>{EVENT.contactEmail}</a>.
          </p>
          <div className="about-actions">
            <Link to="/rules" className="btn btn-outline">Rules & Schedule →</Link>
            <Link to="/register" className="btn btn-primary">Register →</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
